export const PASSWORD_VALIDATION = {
  MIN_LENGTH: 'Minimum 8 characters required.',
  MAX_LENGTH: 'Maximum 20 characters are allowed.',
  FORMAT:
    'Ensure your password is between 8 and 20 characters long, incorporating a mix of lowercase letters (a-z), uppercase letters (A-Z), numbers (0-9), and special characters (e.g., !#$%&()*+,-./:;<=>?@[]^`{|}~) for enhanced security.',
  NO_SPACES: 'Password contains invalid spaces. Please remove any spaces and try again!',
  REQUIRED: 'Please enter password.',
};

export const FIRST_NAME_LENGTHS = {
  MIN: 2,
  MAX: 50,
};

export const LAST_NAME_LENGTHS = {
  MIN: 2,
  MAX: 50,
};

export const FIRST_NAME_VALIDATION = {
  REQUIRED: 'Please enter your Legal First Name.',
  MAX_LENGTH: `Value should be less than ${FIRST_NAME_LENGTHS.MAX} character`,
  MIN_LENGTH: `Must be at least ${FIRST_NAME_LENGTHS.MIN} characters`,
  MIN_MAX_LENGTH: `Legal First Name must be at least ${FIRST_NAME_LENGTHS.MIN} characters and less than ${FIRST_NAME_LENGTHS.MAX} characters`,
  FORMAT: 'Legal First Name may only include letters, spaces, hyphens (-), and apostrophes (\').Consecutive spaces, hyphens, or apostrophes are not allowed.',
};

export const LAST_NAME_VALIDATION = {
  REQUIRED: 'Please enter your Legal Last Name.',
  MAX_LENGTH: `Value should be less than ${LAST_NAME_LENGTHS.MAX} character`,
  MIN_LENGTH: `Must be at least ${LAST_NAME_LENGTHS.MIN} characters`,
  MIN_MAX_LENGTH: `Legal Last Name must be at least ${LAST_NAME_LENGTHS.MIN} characters and less than ${LAST_NAME_LENGTHS.MAX} characters`,
  FORMAT: 'Legal Last  Name may only include letters, spaces, hyphens (-), and apostrophes (\').Consecutive spaces, hyphens, or apostrophes are not allowed.',
};

export const ENTITY_NAME_LENGTHS = {
  MAX: 120,
};

export const ENTITY_NAME_VALIDATION = {
  REQUIRED: 'Please enter the entity name.',
  MAX_LENGTH: `Value should be less than ${ENTITY_NAME_LENGTHS.MAX} characters`,
  NO_LEADING_SPACE: 'Entity name cannot start with a space.',
};

export const ENTITY_TYPE_VALIDATION = {
  REQUIRED: 'Please select the entity type.',
};

export const STATE_OF_INCORPORATION_LENGTHS = {
  MIN: FIRST_NAME_LENGTHS.MIN,
  MAX: FIRST_NAME_LENGTHS.MAX,
};

export const STATE_OF_INCORPORATION_VALIDATION = {
  REQUIRED: 'Please enter the state of incorporation.',
  MAX_LENGTH: `Value should be less than ${STATE_OF_INCORPORATION_LENGTHS.MAX} character`,
  MIN_LENGTH: `Must be at least ${STATE_OF_INCORPORATION_LENGTHS.MIN} characters`,
  FORMAT: 'State of Incorporation may only include letters, spaces, hyphens (-), and apostrophes (\').Consecutive spaces, hyphens, or apostrophes are not allowed.',
};

export const EIN_VALIDATION = {
  FORMAT: 'Please enter a valid EIN in the format XX-XXXXXXX.',
};
